export interface EntityJson {
    id: number;
}

export class Entity {
    constructor(json : EntityJson) {
        this.id = json.id;
    }

    id: number;
}